export * as EVENT_STATUSES from './statuses'

export const VOD_HERO_EVENT_ID = process.env.NEXT_PUBLIC_VOD_HERO_EVENT_ID ?? undefined
